import React from 'react';

export const DownloadIcon: React.FC = () => (
	<svg width='1.7rem' height='2rem' viewBox='0 0 17 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M8.2766 0V14.1489M8.2766 14.1489L13.1277 9.29787M8.2766 14.1489L3.42554 9.29787' stroke='currentColor' strokeWidth='1.5' />
		<path d='M1 15.766V19H15.5532V15.766' stroke='currentColor' strokeWidth='1.5' />
	</svg>
);
